export enum LINK_TYPE {
  TWITTER = 'Twitter',
  FACEBOOK = 'Facebook',
  GITHUB = 'Github',
  DISCORD = 'Discord',
  TELEGRAM = 'Telegram',
  REDDIT = 'Reddit',
  OTHERS = 'Others',
}
